import { TFunction } from 'i18next';
import { DocumentType } from '@steelbuy/ts-shared';

export const FILE_SIZE_LIMIT_IN_MEGABYTES = 5;

export const exceedsMaxFileSize = (fileSize: number) => fileSize > FILE_SIZE_LIMIT_IN_MEGABYTES * 1024 * 1024;

const isPngOrJpg = (fileExtension?: string) =>
    fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg';

const isXlsOrXlsx = (fileExtension?: string) => fileExtension === 'xls' || fileExtension === 'xlsx';

export const isValidFileType = (type: DocumentType, name: string) => {
    const fileExtension = name.split('.').pop()?.toLowerCase();
    if (type === DocumentType.PICTURE && !isPngOrJpg(fileExtension)) {
        return false;
    }

    if (type === DocumentType.ORIGINAL && !isPngOrJpg(fileExtension) && fileExtension !== 'pdf') {
        return false;
    }

    if (type === DocumentType.PACKAGE && !isXlsOrXlsx(fileExtension)) {
        return false;
    }

    if (type === DocumentType.BULK_UPLOAD && !isXlsOrXlsx(fileExtension) && fileExtension !== 'csv') {
        return false;
    }

    return true;
};

export const getRules = (t: TFunction<['translation', 'domainModel', 'uiDomain']>) => ({
    required: () => ({
        required: {
            value: true,
            message: t('uiDomain:validation.requiredField'),
        },
    }),
    min: (value: number, min: number) => ({
        min: {
            value,
            message: t('uiDomain:validation.numberLargerThan', { min }),
        },
    }),
});
